export const ORG_STRUCTURE_BASE_URL = '/ais3/organization-structure';
